<template>

  <div id="HearingCalibrationHeadphone">


    <div>
      <div class="HearingTest-test--text">
        <div class="HearingTest-test--title"><icon name="volume-up"></icon><span> کالیبراسیون صوتی گوش {{ earSide === 'left' ? 'چپ' : 'راست' }}</span></div>
        <div ng-if="!displayComfortText">
          <div v-show="curCalibration == 'first'" class="HearingTest-test--text">
            <strong>بر روی گزینه اجرا کلیک کنید</strong>
            <br>
            <span>صدا را کم و زیاد کنید تا جاییکه احساس کنید سطح شنیداری صدا برای شما <strong>راحت و مناسب</strong> است.</span>
          </div>
          <div v-show="curCalibration == 'second'" class="HearingTest-test--text" >
            <strong>بر روی گزینه اجرا کلیک کنید</strong>
            <br> صدا را تنظیم کنید تا جاییکه <strong>به سختی</strong> بتوانید صدا را بشنوید.
            <br>در مورد تشخیص مواردی که گفته میشود نگران نباشید، لطفا فقط تمرکز کنید که آیا صدایی وجود دارد یا نه؟
          </div>
        </div>
      </div>
    </div>

    <div id="firstCalibration" class="HearingTest-test--calibrationContainer clearfix" v-show="curCalibration == 'first'">

    <v-layout row wrap>
      <v-flex xs12 text-xs-center>
        <v-layout row wrap>
          <v-flex sm4 xs6 text-xs-center v-show="showVolumeAdjusters" >
            <div class="HearingTest-test--volumeContainer"@click="lowerVolume(5,6)">
          <div class="HearingTest-test--volumeControlContainer">
            <div class="HearingTest-test--volumeControl">
              <icon name="minus-circle"></icon>
            </div>
          </div>
          <div class="HearingTest-test--volumeButton ng-binding">ملایمتر</div>
        </div>
          </v-flex>
          <v-flex sm4 xs6 text-xs-center class="play-volume">
            <div class="HearingTest-test--spinner">
          <div class="HearingTest-test--playButtonContainer" v-bind:class="{'Active': showVolumeAdjusters}">
            <div class="HearingTest-test--playButton" v-show="!showVolumeAdjusters" @click="audioCalibrationPlay()">
              <span class="play-icon"><icon name="play"></icon></span>
            </div>
            <div class="HearingTest-test--volume" v-show="showVolumeAdjusters" >{{ currVol }}%</div>
          </div>
          <div class="HearingTest-test--spinnerBar" v-bind:class="{'Active': showVolumeAdjusters}"></div>
        </div>
          </v-flex>

          <v-flex sm4 xs6 text-xs-center v-show="showVolumeAdjusters">
            <div class="HearingTest-test--volumeContainer" @click="raiseVolume(5,96)">
        <div class="HearingTest-test--volumeControlContainer">
          <div class="HearingTest-test--volumeControl">
            <icon name="plus-circle"></icon>
          </div>
        </div>
        <div class="HearingTest-test--volumeButton">بلندتر</div>
      </div>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 text-xs-center>
        <div class="HearingTest-test--textButton" v-show="showVolumeAdjusters" @click="nextCalibrationPart()"><span>ادامه   &gt;</span></div>
      </v-flex>
    </v-layout>

    </div>

    <div id="secondCalibration" class="HearingTest-test--calibrationContainer clearfix" v-show="curCalibration == 'second'">

      <v-layout row wrap>
        <v-flex xs12 text-xs-center>
          <v-layout row wrap>
            <v-flex sm4 xs6 text-xs-center v-show="showVolumeAdjusters" >
              <div class="HearingTest-test--volumeContainer" v-show="showVolumeAdjusters" @click="lowerVolume(1,1)">
        <div class="HearingTest-test--volumeControlContainer">
          <div class="HearingTest-test--volumeControl">
            <icon name="minus-circle"></icon>
          </div>
        </div>
        <div class="HearingTest-test--volumeButton ng-binding">ملایمتر</div>
      </div>
            </v-flex>
            <v-flex sm4 xs6 text-xs-center class="play-volume">
              <div class="HearingTest-test--spinner">
                <div class="HearingTest-test--playButtonContainer" v-bind:class="{'Active': showVolumeAdjusters}">
                  <div class="HearingTest-test--playButton" v-show="!showVolumeAdjusters" @click="audioCalibrationPlay()">
                    <span class="play-icon"><icon name="play"></icon></span>
                  </div>
                  <div class="HearingTest-test--volume" v-show="showVolumeAdjusters" >{{ currVol }}%</div>
                </div>
                <div class="HearingTest-test--spinnerBar" v-bind:class="{'Active': showVolumeAdjusters}"></div>
              </div>
            </v-flex>

            <v-flex sm4 xs6 text-xs-center v-show="showVolumeAdjusters" >
              <div class="HearingTest-test--volumeContainer" v-show="showVolumeAdjusters" @click="raiseVolume(1,MaxVol)">
                <div class="HearingTest-test--volumeControlContainer">
                  <div class="HearingTest-test--volumeControl">
                    <icon name="plus-circle"></icon>
                  </div>
                </div>
                <div class="HearingTest-test--volumeButton">بلندتر</div>
              </div>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 text-xs-center>
          <div class="HearingTest-test--textButton" v-show="showVolumeAdjusters" @click="nextCalibrationPart()"><span>ادامه</span>  &gt;</div>
        </v-flex>

      </v-layout>

    </div>

  </div>

</template>

<script>
    import continuousDiscourse_L from '@/assets/sounds/calibration/continuousDiscourse_L.mp3';
    import continuousDiscourse_R from '@/assets/sounds/calibration/continuousDiscourse_R.mp3';
export default {
    name: 'HearingCalibrationHeadphone',

    components: {

    },
  mounted() {
      this.currAudio = this.audioL;
      this.currVol =40;

  },
  data () {

    return {
        audioL: new Audio(continuousDiscourse_L),
        audioR: new Audio(continuousDiscourse_R),
        currAudio: null,
        earSide: 'left',
        curCalibration: 'first',
        showVolumeAdjusters: false,
        currVol :0,
        currVolShow: 0,
        MaxVol:0,
        speakerAnswer : {
            type:'headphone',
            data:[]
        },
    }
  },
    methods:{
        audioCalibrationPlay(){
            this.showVolumeAdjusters = true;

            this.currAudio.volume = this.currVol / 100;
            this.currAudio.addEventListener('ended', function() {
                this.currentTime = 0;
                this.play();
            }, false);
            this.currAudio.play();
        },
        lowerVolume(vol,lower){

            if(this.currVol > lower)
                this.currAudio.volume = ((this.currVol -= vol) / 100).toFixed(2);
        },
        raiseVolume(vol,riser){
            if(this.curCalibration === "second")
                riser = riser >= 10 ? riser-4 : riser / 2 ;
            if(this.currVol < riser)
                this.currAudio.volume =  ((this.currVol += vol) / 100).toFixed(2);
        },
        nextCalibrationPart(){
            this.currAudio.pause();
            this.currAudio.currentTime = 0;

            switch (this.earSide){
                case 'left':
                    if(this.curCalibration === "first") {
                        this.speakerAnswer.data['leftFirst'] = this.currVol;
                        this.MaxVol = Math.ceil(this.currAudio.volume * 100);
                        //console.log(this.currVol, this.currAudio.volume);
                        this.currVol =  Math.ceil(this.currAudio.volume*50);
                        this.currAudio.volume = parseFloat((this.currVol / 100).toFixed(2));

                        this.curCalibration = "second";
                    }else{
                        this.speakerAnswer.data['leftSecond'] = this.currVol;
                        this.curCalibration = "first";
                        this.currAudio = this.audioR;
                        this.currVol = 40;
                        this.currAudio.volume = (this.currVol / 100).toFixed(2);
                        this.earSide = 'right';
                    }
                    break;
                case 'right':
                    if(this.curCalibration === "first") {
                        this.speakerAnswer.data['rightFirst'] = this.currVol;

                        this.MaxVol = Math.ceil(this.currAudio.volume * 100);
                        //console.log(this.currVol, this.currAudio.volume);
                        this.currVol =  Math.ceil(this.currAudio.volume*50);
                        this.currAudio.volume =  parseFloat((this.currVol / 100).toFixed(2));

                        this.curCalibration = "second";
                    }else{
                        this.speakerAnswer.data['rightSecond'] = this.currVol;
                        this.saveCalibrations();
                    }
                    break;
            }

            this.showVolumeAdjusters = false;


        },
        saveCalibrations(){
            this.currAudio.pause();
            this.currAudio.currentTime = 0;
            window.calibrationAnswers = this.speakerAnswer;
            //console.log("save calibrationAnswers Headphone",window.calibrationAnswers);
            this.$parent.$router.replace('/pure_tone_test');
        },
    }
}
</script>

<style scoped>
  #HearingCalibrationHeadphone{
    margin: 40px;
    padding: 0 10px 100px;
  }
  .play-volume{
    position: relative;
    width: 130px;
    height: 130px;
  }
  .HearingTest-test--title {
    text-align: center;
    margin-bottom: 10px;
    font-weight: normal;
    font-style: normal;
    font-size: 36px;
    line-height: 52px;
    color: #00b7c6;
  }
  .HearingTest-test--text {
    text-align: center;
    margin-bottom: 20px;
    font-weight: normal;
    font-style: normal;
    font-size: 16px;
    line-height: 22px;
    color: #000;
  }
  .HearingTest-test--calibrationContainer {
    text-align: center;
    display: table;
    margin: 0 auto;
  }
  .HearingTest-test--calibrationContainer .HearingTest-test--spinner {
    text-align: center;
    width: 120px;
    height: 120px;
    border: 15px solid #fff;
    border-radius: 120px;
    -webkit-box-shadow: 0px 0px 1px;
    box-shadow: 0px 0px 1px;
    margin: 0 auto;
  }
  @media (max-width: 599px){
    .HearingTest-test--calibrationContainer .HearingTest-test--spinner{

      margin: 65px auto 0;
      position: absolute;
    }
    .HearingTest-test--calibrationContainer .HearingTest-test--volumeContainer {
      text-align: center;
      width: 100px;
      margin: 0 auto 0;
    }
  }

  .HearingTest-test--calibrationContainer .HearingTest-test--spinner .HearingTest-test--playButtonContainer .HearingTest-test--playButton .play-icon {
    text-align: center;
    color: #fff;
    position: absolute;
    font-size: 40px;
    left: 50%;
    margin-left: -12px;
    top: 50%;
    margin-top: -20px;
  }
  .HearingTest-test--calibrationContainer .HearingTest-test--spinner .HearingTest-test--playButtonContainer {
    text-align: center;
    position: absolute;
    z-index: 5;
    width: 100px;
    height: 100px;
    margin-right: -5px;
    margin-top: -5px;
    background-color: #00b7c6;
    border-radius: 120px;
    cursor: pointer;
    box-shadow: 0px 0px 1px;
    box-sizing: content-box;
    -webkit-box-sizing: content-box;
    -moz-box-sizing: content-box;
  }
  .HearingTest-test--calibrationContainer .HearingTest-test--spinner .HearingTest-test--playButtonContainer.Active {
    background-color: #b5be00;
  }
  .HearingTest-test--calibrationContainer .HearingTest-test--spinner .HearingTest-test--playButtonContainer.Active:hover {
    background-color: #b5be00;
  }
  .HearingTest-test--calibrationContainer .HearingTest-test--spinner .HearingTest-test--spinnerBar.Active {
    position: absolute;
    width: 130px;
    height: 130px;
    margin-right: -20px;
    margin-top: -20px;
    border: 5px solid #b5be00;
    border-radius: 130px;
    opacity: 1;
  }
  .HearingTest-test--calibrationContainer .HearingTest-test--spinner .HearingTest-test--playButtonContainer:hover {
    background-color: #ea7600;
  }
  .HearingTest-test--calibrationContainer .HearingTest-test--spinner .HearingTest-test--playButtonContainer .HearingTest-test--playButton {
    text-align: center;
    position: absolute;
    width: 100px;
    height: 100px;
  }
  .HearingTest-test--calibrationContainer .HearingTest-test--spinner .HearingTest-test--playButtonContainer .HearingTest-test--volume {
    text-align: center;
    margin: 31px auto 0;
    font-weight: normal;
    font-style: normal;
    font-size: 44px;
    line-height: 44px;
    color: #fff;
  }
  .HearingTest-test--calibrationContainer .HearingTest-test--volumeContainer {
    text-align: center;
    width: 100px;
    margin: 10px auto 0;
  }
  .HearingTest-test--calibrationContainer .HearingTest-test--volumeContainer .HearingTest-test--volumeControlContainer {
    text-align: center;
    opacity: 1;
  }
  .HearingTest-test--calibrationContainer .HearingTest-test--volumeContainer .HearingTest-test--volumeControlContainer .HearingTest-test--volumeControl {
    text-align: center;
    margin-bottom: 10px;
    font-size: 30px;
    line-height: 30px;
    color: #666;
    cursor: pointer;
  }
  .HearingTest-test--calibrationContainer .HearingTest-test--volumeContainer .HearingTest-test--volumeButton {
    text-align: center;
    margin-left: 0px;
  }

  .HearingTest-test--calibrationContainer .HearingTest-test--volumeButton {
    text-align: center;
    cursor: pointer;
    background-color: #00b7c6;
    padding-top: 7px;
    padding-bottom: 7px;
    font-weight: normal;
    font-style: normal;
    font-size: 18px;
    line-height: 18px;
    color: #fff;
    -webkit-box-shadow: 0px 5px 5px 0px rgba(0, 0, 0, 0.15);
    -moz-box-shadow: 0px 5px 5px 0px rgba(0, 0, 0, 0.15);
    box-shadow: 0px 5px 5px 0px rgba(0, 0, 0, 0.15);
  }
  .HearingTest-test--calibrationContainer .HearingTest-test--volumeButton:hover {
    background-color: #ea7600;
  }
  .HearingTest-test--textButton {
    text-align: center;
    display: inline-block;
    margin: 24px auto 0;
    font-weight: normal;
    font-style: normal;
    font-size: 30px;
    line-height: 30px;
    color: #00b7c6;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/HearingTest/HearingCalibrationHeadphone.vue